import React from 'react';
import { i18n } from '@lingui/core';
import { parseISODate } from '@ygtechnologies/rubus-frontend-utilities';

interface IOwnProps {
    value?: Date | string;
    monthTextForm?: boolean;
}

function DateDisplay({ value, monthTextForm = false }: IOwnProps) {
    if (!value) {
        return null;
    }

    return <>{i18n.date(parseISODate(value), { year: 'numeric', month: monthTextForm ? 'short' : '2-digit', day: '2-digit' })} </>;
}

export default React.memo(DateDisplay);